import AppLayout from "@/components/feature/AppLayout";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import LatestEpisodes from "@/pages/home/components/LatestEpisodes";
import PlotAnalysis from "@/pages/home/components/PlotAnalysis";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  useDocumentMeta({
    title: "出轨的味道影视剧大全及剧情介绍",
    description:
      "出轨的味道官网为您提供最新影视剧全集、剧情介绍及演员信息，涵盖该剧相关资讯与内容，满足您对影视剧的全面需求。",
    keywords: "出轨的味道,出轨的味道影视剧,出轨的味道剧情,电视剧全集,剧情介绍,影视资讯,电视剧下载,演员名单",
  });

  return (
    <AppLayout>
      <HeroCarousel />
      <LatestEpisodes />
      <PlotAnalysis />
      <SiteIntro />
    </AppLayout>
  );
}